
/**
 * 用于控制新颖性检查功能的服务
 */
export interface DisclosureFeatureControlService {
    /**
    * 是否允许AI优化
    */
    isOptimizationEnabled: boolean
    /**
     * 是否允许编辑
     */
    isEditEnabled: boolean;
    /**
     * 是否允许隐藏
     */
    isHiddenEnabled: boolean;
    /**
     * 是否允许调整内容
     */
    isContentAdjustmentEnabled: boolean;
    /**
     * 是否允许创建新任务
     */
    isCreateNewTaskEnabled: boolean;
    /**
     * 是否允许导出
     */
    isExportEnabled: boolean;
}

export const DisclosureFeatureControlService = Symbol.for('DisclosureFeatureControlService');
